import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NmDatatableSettings } from '../../../widgets/datatable/datatable.interface';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'teachers-search-page',
	templateUrl: './search.html',
	styleUrls: ['./search.css']
})
export class TeachersSearchPage {
	public modelName: string = 'teacher';
	public syncBtnStatus: boolean = true;
	public reloadTable: boolean = false;
	public searched: boolean = false;
	

	public form: FormGroup = this.formBuilder.group({
		// basic information
		file: ['',Validators.required],
	});
	public searchForm: FormGroup = this.formBuilder.group({
		// basic information
		SchoolId: [''],
		Salutation: [''],
		Name: [''],
		NameChinese: [''],
		Telephone1: [''],
		Telephone2: [''],
		EmailAddress1: [''],
		EmailAddress2: [''],
	});
	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,
		public _form: FormService,
		public _searchForm: FormService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		this._form.setForm(this.form);
		this._searchForm.setForm(this.searchForm);
		this.onBeforeRendered();
		let params = this.activatedRoute.snapshot.queryParams;
		
		let initSearch: boolean = false;
		for(let key in params){
			if(params[key] && this.searchForm.controls[key]){
				this.searchForm.controls[key].setValue(params[key]);
				initSearch = true;
			}
			if(key == 'searchall'){
				initSearch = true;
			}
		}
		if(initSearch){
			this.onSearch();
		}
		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}

	private syncPromise(): Promise<any>[]{
		let promises:Promise<any>[] = [];
		let limit=200;
		for(let offset:number = 0;offset<=1200;offset = offset+limit){
			promises.push(this.api.sendApiRequest('get', 'school/sync/'+limit+'/'+offset).toPromise());
		}
		return promises;
	}
	public onSyncSchool(): void {
		this.syncBtnStatus = false;
		
		
		try {
			//let promise;
			//promise = this.api.sendApiRequest('get', 'school/sync').toPromise();
			

			Promise.all(this.syncPromise())
			.then(res => {
				this.onAfterSubmit(true);
				this.syncBtnStatus = true;
			})
			.catch(err => {
				this.onAfterSubmit(false);
				this.syncBtnStatus = true;
			});
		}
		catch(e) {
			console.error(e);
				this.syncBtnStatus = true;
		}
		
	}
	public onAfterSubmit(success: boolean): void {
		if(success) {
			bootbox.alert({
				message: 'success synchronized',
				callback:() => {
					
				}
			});
		}
	};
	
	public onSearch():void{
		//console.log(this.searchForm.value);
		let fullMath = ['SchoolId'];
		this.datatableSetting.fields.map(v => {
			this.searchForm.value[v.name] ? v.search = this.searchForm.value[v.name] : v.search = '';
			for(let k of fullMath){
				if(v.search && v.name == k){
					v.regex = true;
					v.search = '^'+v.search+'$';
				}
			}
			return v;
		});
		//console.log(this.datatableSetting);
		this.searched = true;
		this._setSearchUrl();
	}
	private _setSearchUrl(){
		let querys = [];
		for(let name in this.searchForm.value){
			if(this.searchForm.value[name]){
				querys.push(name+'='+this.searchForm.value[name]);
			}
		}
		
		let queryStr = querys.join('&');
		if(!queryStr){
			queryStr = 'searchall=1';
		}
		this.location.replaceState('/teachers/search',queryStr);
		
	}

	public onSearchClear(): void{
		/*$('select').val(null);
		$('select').trigger('chosen:updated');
		this.searchForm.reset();*/
		for(let it in this.searchForm.controls){
			this.searchForm.controls[it].setValue('');
		}
		//$('select').val(null);
		//$('select').trigger('chosen:updated');
	}
	public onBackSearch(): void{
		this.searched = false;
	}
	public datatableSetting: NmDatatableSettings = {
		modelName: 'teacher',
		fields: [
			{ name: 'Salutation', label: 'Salutation', sortable: false, searchable: true, },
			{ name: 'Name', label: 'Name (English)', sortable: false, searchable: true, },
			{ name: 'NameChinese', label: 'Name (Chinese)', sortable: false, searchable: true, },
			{ name: 'SchoolId', label: 'School ID', sortable: false, searchable: true, },
			{ name: 'SchoolName', label: 'School Name', sortable: false, searchable: true, },
			{ name: 'NameChinese', label: 'Name (Chinese)', sortable: false, searchable: true, },
			{ name: 'JobPosition', label: 'Position / Title', sortable: false, searchable: true, },
			{ name: 'SubjectsTaught', label: 'Subjects taught / Department', sortable: false, searchable: true, },
			{ name: 'Telephone1', label: 'Tel (Office)', sortable: false, searchable: true, },
			{ name: 'Telephone2', label: 'Tel (Mobile)', sortable: false, searchable: true, },
			{ name: 'Fax', label: 'Fax', sortable: false, searchable: true, },
			{ name: 'EmailAddress1', label: 'Email (Work)', sortable: false, searchable: true, },
			{ name: 'EmailAddress2', label: 'Email (Personal)', sortable: false, searchable: true, },
			{ name: 'InCharge', label: 'YFS Teacher in charge', sortable: false, searchable: true, },
			
			
		],
		actions: [
			{ name: 'view', icon: 'search-plus', color: 'blue', show: () => true,
				callback: function(id, data) { this.router.navigate([`/teachers/view/${id}`]); }
			},
			{ name: 'edit', icon: 'pencil', color: 'green', show: () => true,
				callback: function(id, data) { this.router.navigate([`/teachers/edit/${id}`]); }
			},
			{ name: 'delete', icon: 'trash', color: 'red', show: () => true },
		],
		ajax: {
			url: 'teacher/datatables'
		},
		ajaxDataMassage: (data: any[]) => {
			
			return data.map(v => {
				
				v.id = v.TeacherId;
				v.InCharge = (v.InCharge == '1' ? 'Yes' : 'No');
				v.SchoolName = (v.school ? v.school.SchoolCompleteName : '');

				return v;
			})
		}
	};
}



// WEBPACK FOOTER //
// ./src/pages/teachers/search/search.ts